import React, { useState } from 'react'
import './Footer.css'
import '../../App.css'
import SubmitConfirmationComponent from '../React/Modal/SubmitModalComponent';
export const Footer = () => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <section className='foot'>
                <div className="container ">
                    <div className="row items">
                        <div className="col-lg-start col-lg-5 col-md-6 col-sm-12 text-center">
                            <span className='card-head'>Lacuna Venture</span>
                            <p >Lacuna Venture Startup academy is an entrepreneurial workshop community for startup founders, entrepreneurs, and investors. Our design thinking sessions create an entrepreneurial process that can help entrepreneurs and startup founders systematically extract, educate, learn, and apply those human-centered techniques to solve problems in a creative and innovative way-in our personal and professional life.
                            </p>
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-12 text-center">
                            <span className='card-head'>Information</span>
                            <ul className="list-unstyled">
                                <li><a href="">FAQ </a></li>
                                <li><a href=""> Blog</a></li>
                                <li><a href=""> Support</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-12 text-center foot">
                            <span className='card-head'>Company</span>
                            <ul className="list-unstyled">
                                <li><a href="">About us </a></li>
                                <li><a href="">Career</a></li>
                                <li><a href="">Contact  us </a></li>
                                <li><a href="">Lift media</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 foot">
                            {/* <h3 className='text-center card-head2'>Keep awake & Grab Unlimited Offers</h3> */}
                            <div className="btn2">
                                <div className="container">
                                    <div className="row items">
                                        {/* <div className="col-lg-3 col-md-6 col-sm-12  mt-md-2 mt-lg-0"> */}
                                            {/* <h3 className='text-center card-head2'>Keep awake & Grab Unlimited Offers</h3> */}
                                            <div className="btn2">

                                            <button class='btn btn-pri' onClick={() => setShowModal(true)}>Subscribe</button>
                                            </div>
                                            <p className='mt-1 text-center'>
                                            Get notified for our upcoming events, news, exclusive offers, services and products from Lacuna Venture. 
                                            </p>

                                            <SubmitConfirmationComponent 
                                                show={showModal}
                                                setShowModal={() => setShowModal(false)}
                                                modalHeader="Keep awake & Grab Unlimited Offers"
                                            />
                                            
                                            {/* <div class="modal fade" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                <div class="modal-dialog">
                                                    <div class="modal-content">
                                                        <div class="modal-header">
                                                        <h5 class="modal-title" >Keep awake & Grab Unlimited Offers</h5>
                                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                        </div>
                                                        <div class="modal-body py-2">
                                                    
                                                            <form>
                                                                <div class="mb-3">
                                                                    <label for="exampleInputPassword1" class="form-label ">Full Name</label>
                                                                    <input type="password" class="form-control" id="exampleInputPassword1"/>
                                                                </div>
                                                                <div class="mb-3">
                                                                    <label for="exampleInputEmail1" class="form-label">Email address</label>
                                                                    <input type="email" class="form-control" placeholder='example123@gmail.com' aria-describedby="emailHelp"/>
                                                                    
                                                                </div>
                                                            
                                                        
                                                            </form>
                                                        </div>
                                                        <div class="modal-footer">
                                                            <button type="button" class="btn" data-bs-dismiss="modal">Close</button>
                                                            <button type="submit" class="btn btn-pri">Submit</button>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
         
                
            <div className="footer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col md-6 text-md-start text-center ">
                            <ul className="list-unstyled  tcc">
                                <li><a href="">Terms</a></li>
                                <li><a href=""> Condition</a></li>
                                <li><a href=""> Cookies</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 ">
                            <ul className="list-unstyled logItem d-flex justify-content-center  mb-3 mb-md-0">
                        
                                <li><a href="https://www.instagram.com/lacunaventure/" target="_blank" ><i class="fab fa-instagram icon1"></i></a> </li>
                                <li><a href="https://twitter.com/lacunaventure" target="_blank"><i class="fab fa-twitter icon1"></i></a> </li>
                                <li><a href="https://www.linkedin.com/company/lacunaventure/" target="_blank"><i class="fa-brands fa-linkedin icon1"></i> </a> </li>
                                <li><a href="https://www.facebook.com/lacunaventurefamily/" target="_blank"><i class="fab fa-facebook icon1"></i></a> </li>
                                <li><a href="https://www.youtube.com/channel/UCAQ2bxPzuznPVGBtUy1x6hQ" target="_blank"><i class="fab fa-youtube icon1"></i> </a> </li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="copyright mb-3 text-lg-start text-center mb-md-0">
                                <p className="mb-0 text-center"> <a href="#">copyright2022@Lacuna venture</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}